export const POSTS = 'Posts'
export const FAVORITES = 'Favorites'
export const LIKEDS = 'Likeds'
export const CREATE_A_POST = 'Create a Post'
export const FOLLOWING = 'Following'

export const PROFILE = 'Profile'
export const LOGOUT = 'Logout'
